import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { userValidateToken, loginSso, setUserInfoFromStorage } from 'src/ui/features/Login/state/loginActions';
import { addToHistory } from 'src/utils/utilsActions';
import { LOGIN_URL, SECURITY_ROUTES, COOKIES } from 'src/constants/constants.js';
import { throttle } from 'src/helpers';
import { userRolesConfig } from 'src/helpers';
import cookie from 'react-cookies';
import { getDashboardURL } from 'src/helpers/commonFunctions';

class Security extends React.Component {
  static propTypes = {
    /** Validate user tokens */
    userValidateToken: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));

    if (userInfo) {
      this.props.setUserInfoFromStorage({ userInfo });
    }

    this.state = {
      mountRoles: userInfo ? userRolesConfig({ userInfo }) : null,
      forceValidation: window.top.location.pathname !== '/' ? true : false,
    };
  }

  checkRouteAllowed = route => {
    let roleType = null;
    const { mountRoles } = this.state;
    const userRoles = mountRoles ? mountRoles : this.props.userRoles;

    Object.keys(userRoles).forEach(key => {
      if (userRoles[key] === true) {
        roleType = key;
      }
    });

    const routesAllowed = SECURITY_ROUTES[roleType];
    if (!routesAllowed) {
      return;
    }

    const isRouteMatch = routesAllowed.filter(item => item !== '/' && route.indexOf(item) > -1).length > 0;

    if (route !== '/' && !isRouteMatch) {
      window.location.href = getDashboardURL();
    }
  };

  componentDidMount() {
    const { isAuthenticated, history, userValidateToken, loginSso } = this.props;
    const currentRoute = window.top.location.pathname;

    // if this is coming back from sso ping redirect, set the location back to the route the user came in on
    var entryCookie = cookie.load(COOKIES.ENTRY_PATH);
    if (entryCookie != null && entryCookie !== '' && entryCookie !== '_ey_pathway_redirected') {
      var entryPath = entryCookie;
      cookie.save(COOKIES.ENTRY_PATH, '_ey_pathway_redirected', { secure: true }); //, { httpOnly: true, secure: true }
      window.location.href = entryPath;
    }

    this.checkRouteAllowed(currentRoute);

    if (!isAuthenticated && currentRoute !== LOGIN_URL) {
      entryCookie = cookie.load(COOKIES.ENTRY_PATH);

      if (entryCookie == null || entryCookie === '') {
        cookie.save(COOKIES.ENTRY_PATH, currentRoute, { secure: true }); //, { httpOnly: true, secure: true }
      }

      loginSso();
    } else if (currentRoute === LOGIN_URL) {
      cookie.save(COOKIES.ENTRY_PATH, '_ey_pathway_redirected', { secure: true }); //, { httpOnly: true, secure: true }
      return null;
    }

    const validateTokenFn = throttle(() => userValidateToken(), 120000);

    if (process.env.NODE_ENV !== 'test') {
      history.listen((location, action) => {
        this.checkRouteAllowed(window.location.pathname);
        validateTokenFn();
      });
    }
  }

  render() {
    if (this.state.forceValidation && !this.props.isAuthenticated) {
      return null;
    } else {
      return this.props.children;
    }
  }
}

const mapStateToProps = state => ({
  userInfo: state.login,
  isAuthenticated: state.login.isAuthenticated,
  userRoles: state.login.userRoles,
});

const mapDispatchToProps = {
  userValidateToken,
  setUserInfoFromStorage,
  addToHistory,
  loginSso,
};

export default connect(mapStateToProps, mapDispatchToProps)(Security);
